/**
 * Normalize text that may already be HTML-entity encoded from the API/storage.
 * Order matters: decode &amp; before other entities (handles &amp;#39; → ').
 */
function decodeHtmlEntities(text) {
  return String(text)
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&quot;/gi, '"')
    .replace(/&#39;/gi, "'")
    .replace(/&apos;/gi, "'");
}

/** Quote forms that may appear after escaping mention/hash-tag span markup. */
const SPAN_CLASS_QUOTE = "(?:&#39;|&quot;|'|\")";

/**
 * Escape HTML, then re-enable only intentional tagged-name / hash-tag spans
 * saved by the @ mention picker or tag UI.
 *
 * Raw typed text like "@suriya" stays plain; only
 * <span class='tagged-name'>...</span> spans are treated as real mentions.
 * Bare #tags are highlighted for display.
 *
 * @param {unknown} value
 * @returns {string} Safe HTML for v-html
 */
export function formatCommentMessage(value) {
  if (value == null) return '';
  let result = decodeHtmlEntities(String(value));
  result = result
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
  result = result.replace(
    new RegExp(
      `&lt;span class=${SPAN_CLASS_QUOTE}tagged-name${SPAN_CLASS_QUOTE}&gt;([\\s\\S]*?)&lt;/span&gt;`,
      'gi',
    ),
    "<span class='tagged-name'>$1</span>",
  );
  result = result.replace(
    new RegExp(
      `&lt;span class=${SPAN_CLASS_QUOTE}hash-tag${SPAN_CLASS_QUOTE}&gt;([\\s\\S]*?)&lt;/span&gt;`,
      'gi',
    ),
    "<span class='hash-tag'>$1</span>",
  );
  // #tags stay visually highlighted; raw @text stays plain
  result = result.replace(/(?<![\w#])#([A-Za-z0-9_]+)\b/g, "<span class='hash-tag'>#$1</span>");
  return result;
}
